import { readConfig } from 'shared/utils/readConfig';
import { AzureAuth } from 'shared/auth-providers';

const { config } = readConfig<{ provider: 'AzureAuth'; config: any }>('AUTH');

export const Authentication = AzureAuth.create(config);
